<div class="close-container flex">
    <img src="../assets/close_icon.svg" [mat-dialog-close]="false" class="dialog-close-icon" alt="" aria-hidden="true">
</div>
<div class="flex-column">
    <h1 class="font-35">Vehicle Found</h1>
    <p class="font-17">{{vehicleAlreadyAssociated ? '' : 'We have a vehicle that may be yours:'}}</p>
    <div class="flex">
        <div class="two-col">
            <img class="car-image" src="../assets/accord-vehicle.png" alt="Vehicle">
        </div>
        <div class="two-col car-name">
            <p class="vehicle-name font-24">2021 Accord Touring</p>
            <p class="vin font-17">VIN: 19UYA31581L000000</p>
        </div>

    </div>
    <div class="flex" *ngIf="!vehicleAlreadyAssociated">
        <div class="two-col">
            <div class="info-container flex">
                <mat-icon class="">lock</mat-icon>
                <div class="flex flex-wrap">
                    <p class="heading">Remote Start</p>
                    <p class="description">Get comfy by colling down or warmng up your car ahead of time.</p>
                </div>
            </div>
            <div class="info-container flex mt-25">
                <mat-icon class="">lock</mat-icon>
                <div class="flex flex-wrap">
                    <p class="heading">Security Alarm Alert</p>
                    <p class="description">Receive timely alerts when your vehicle alarm is triggered.</p>
                </div>
            </div>
        </div>
        <div class="two-col">
            <div class="info-container flex">
                <mat-icon class="">lock</mat-icon>
                <div class="flex flex-wrap">
                    <p class="heading">Remote Lock & Unlock</p>
                    <p class="description">Remotely lock or unlock the car doors using the app.</p>
                </div>
            </div>
            <!-- <div class="info-container flex mt-25">
                <mat-icon class="">lock</mat-icon>
                <div class="flex flex-wrap">
                    <p class="heading">Driver Feedback</p>
                    <p class="description">Get a score based on how you drive. The better your driving habits, the
                        better your score.View your trip history and get tips on improving your score.</p>
                </div>
            </div> -->
        </div>
    </div>
    <div class="mt-25 associated-text-container" *ngIf="vehicleAlreadyAssociated ">
        <p class="heading">This vehicle is already associated with another account</p>
        <p class="description">If you share this vehicle, please contact the account owner and request to be added through the Manage Drivers feature.</p>
    </div>
    <div class="flex justify-content-center action-btn-container mt-80">
        <button mat-flat-button class="edit-form-button standard-btn danger-btn" >Cancel</button>
        <button mat-flat-button class="edit-form-button standard-btn primar-btn" *ngIf="vehicleAlreadyAssociated">Sign In with Associated Account</button>
        <button mat-flat-button class="edit-form-button standard-btn primar-btn" *ngIf="vehicleAlreadyAssociated">Transfer to My Account</button>
        <button mat-flat-button class="edit-form-button standard-btn primar-btn" *ngIf="!vehicleAlreadyAssociated">Add a Different Vehicle</button>
        <button mat-flat-button class="edit-form-button standard-btn primar-btn" *ngIf="!vehicleAlreadyAssociated" (click)="onClickAddThisVehicle()">Add This Vehicle</button>
    </div>
</div>